/** Lokale Kalenderdaten als YYYY-MM-DD, damit UTC keine Tage verschiebt. */
export function datumHeute(): string {
  return datumVon(new Date())
}

export function datumVon(datum: Date): string {
  const jahr = datum.getFullYear()
  const monat = String(datum.getMonth() + 1).padStart(2, '0')
  const tag = String(datum.getDate()).padStart(2, '0')
  return `${jahr}-${monat}-${tag}`
}

export function datumLesen(wert: string): Date {
  const [jahr, monat, tag] = wert.split('-').map(Number)
  return new Date(jahr ?? 0, (monat ?? 1) - 1, tag ?? 1)
}

export function tageAddieren(wert: string, tage: number): string {
  const datum = datumLesen(wert)
  datum.setDate(datum.getDate() + tage)
  return datumVon(datum)
}

export function monatsFenster(wert: string): { von: string; bis: string } {
  const datum = datumLesen(wert)
  const von = new Date(datum.getFullYear(), datum.getMonth(), 1)
  const bis = new Date(datum.getFullYear(), datum.getMonth() + 1, 0)
  return { von: datumVon(von), bis: datumVon(bis) }
}

export function instanzSchluessel(id: string, occurrenceDate: string | null): string {
  return `${id}:${occurrenceDate ?? 'ohne-datum'}`
}

export function datumKurz(wert: string): string {
  return datumLesen(wert).toLocaleDateString('de-DE', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  })
}

export function zeitKurz(wert: string | null, zeitzone?: string): string | null {
  if (!wert) return null
  return new Date(wert).toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    ...(zeitzone ? { timeZone: zeitzone } : {}),
  })
}

/** Montag bis Sonntag der Woche, in der dieser Tag liegt - das Raster beginnt montags. */
export function wochenFenster(wert: string): { von: string; bis: string } {
  const d = datumLesen(wert)
  // getDay(): 0 = Sonntag. Auf ISO umrechnen, sonst beginnt die Woche falsch.
  const iso = d.getDay() === 0 ? 7 : d.getDay()
  const von = tageAddieren(wert, -(iso - 1))
  return { von, bis: tageAddieren(von, 6) }
}

/** Berechnet das Alter in vollen Lebensjahren oder null, falls kein/ungültiges Datum. */
export function alterBerechnen(wert: string | null | undefined): number | null {
  if (!wert || !/^\d{4}-\d{2}-\d{2}$/.test(wert)) return null
  const geburt = datumLesen(wert)
  if (isNaN(geburt.getTime())) return null
  const heute = new Date()
  let alter = heute.getFullYear() - geburt.getFullYear()
  const monatsDiff = heute.getMonth() - geburt.getMonth()
  if (monatsDiff < 0 || (monatsDiff === 0 && heute.getDate() < geburt.getDate())) {
    alter--
  }
  return alter >= 0 ? alter : null
}

/** Formatiert das Geburtsdatum z. B. als „14.05.2012 (14 Jahre)“. */
export function geburtstagFormatiert(wert: string | null | undefined): string | null {
  if (!wert || !/^\d{4}-\d{2}-\d{2}$/.test(wert)) return null
  const [jahr, monat, tag] = wert.split('-')
  const alter = alterBerechnen(wert)
  const dStr = `${tag}.${monat}.${jahr}`
  if (alter !== null) {
    return `${dStr} (${alter} ${alter === 1 ? 'Jahr' : 'Jahre'})`
  }
  return dStr
}

